module.exports = __webpack_public_path__ + "img/number_header.02f63ce6.jpg";